"use strict";

import {
    ValidationRule,
    ClosureRule,
    AcceptedRule,
    ArrayRule,
    NullableRule,
    RequiredRule,
    RequiredIfRule,
    RequiredWithRule,
    NumericRule,
    PresentRule,
    MinRule,
    MaxRule,
    DateRule,
    StringRule,
} from './rules.js';

/**
 * Static helper class used
 * to generate validation rules.
 * Example:
 *  [Rule.required(), Rule.numeric(), Rule.min(5)]
 * equals to
 *  'required|numeric|min:5'
 */
class Rule {
    /**
     * Check field value with the provided function.
     * 
     * @param {function} handler
     * @returns ValidationRule
     */
    static closure(handler) {
        return new ClosureRule(handler);
    }
    /**
     * 
     * @returns ValidationRule
     */
    static required() {
        return new RequiredRule();
    }
    /**
     * 
     * @returns ValidationRule
     */
    static nullable() {
        return new NullableRule();
    }
    /**
     * 
     * @returns ValidationRule
     */
    static numeric() {
        return new NumericRule();
    }

    /**
     * The field under validation must be present and not empty only if any of the other
     * specified fields are present and not empty.
     * @param {string[]|string} otherFields 
     * @returns ValidationRule
     */
    static requiredWith(otherFields) {
        return new RequiredWithRule(otherFields);
    }

    /**
     * The field under validation must be present and not empty if the anotherfield field is equal to any value.
     * @param {string} otherField Other filed to check
     * @param {string|array|function} values values that the otherField must be equal to, if an array if specified any of the values are accepted, if function is specified the result of the function is checked against the otherField
     * @returns 
     */
    static RequiredIfRule(otherField, values) {
        return new RequiredIfRule(otherField, values);
    }
    /**
     * 
     * @returns ValidationRule
     */
    static present() {
        return new PresentRule();
    }
    /**
     * 
     * @returns ValidationRule
     */
    static accepted() {
        return new AcceptedRule();
    }
    /**
     * 
     * @returns ValidationRule
     */
    static array() {
        return new ArrayRule();
    }
    /**
     * @param {Number} min
     * @returns ValidationRule
     */
    static min(min) {
        return new MinRule(min);
    }

    /**
     * @param {Number} max
     * @returns ValidationRule
     */
    static max(max) {
        return new MaxRule(max);
    }

    static date() {
        return new DateRule();
    }
    static string() {
        return new StringRule();
    }
}
export { Rule, ValidationRule };